namespace Areas.Inspections {
    "use strict";



    export function CancelSelect() {
        $("#ProjectLookupPopup").dxPopup("instance").hide();

    }

    export function SelectProject(e) {

        var dataGrid = $('#ProjectLookupGrid').dxDataGrid('instance');
        var selectedRow: any = dataGrid.getSelectedRowsData();

        if (selectedRow[0] == null) {
            DevExpress.ui.notify("You need to select a Project first!", "warning", 2000);
        } else {

            var inspectionProjectId = selectedRow[0].inspectionProjectId;
            var projectName = selectedRow[0].projectName;
            var projectNumber = selectedRow[0].projectNumber;

            //this is the lookup form _ProjectAreaLookupForm
            var lookupForm: DevExpress.ui.dxForm = $('#ProjectLookupForm').dxForm('instance');
            var lookupData: any = lookupForm.option('formData');

           
            lookupData.ProjectName = projectName;
            lookupData.ProjectNumber = projectNumber;

            var lunumberControl: DevExpress.ui.dxTextBox = lookupForm
                .getEditor('InspectionProjectNumber') as DevExpress.ui.dxTextBox;
            lunumberControl.option("value", projectNumber);

            var lunameControl: DevExpress.ui.dxTextBox = lookupForm
                .getEditor('InspectionProjectName') as DevExpress.ui.dxTextBox;
            lunameControl.option("value", projectName);

            
            //this is the main form _DataForm.cshtml
            var dataForm: DevExpress.ui.dxForm = $('#InspectionsForm').dxForm('instance');
            var newData: any = dataForm.option('formData');

            newData.InspectionProjectId = inspectionProjectId;


            $("#ProjectLookupPopup").dxPopup("instance").hide();

        }
    } 

                                                
    export function typeValueChanged(e) {

        var inspectionForm: DevExpress.ui.dxForm = $('#InspectionsForm').dxForm('instance');
        
        var subTypeLookupControl: DevExpress.ui.dxLookup = inspectionForm.getEditor("InspectionSubTypeLk") as DevExpress.ui.dxLookup;

        Areas.Inspections.inspectionTypeLk = e.value;
        subTypeLookupControl.getDataSource().reload();
        subTypeLookupControl.reset();
    }

    export function inspectionRequestedDateChanged(e) {

        var inspectionForm: DevExpress.ui.dxForm = $('#InspectionsForm').dxForm('instance');

        var dateBoxControl: DevExpress.ui.dxDateBox = inspectionForm.getEditor("InspectionRequestedDate") as DevExpress.ui.dxDateBox;

        var isAdmin: any = $('#InspectionsForm').dxForm('instance').option('IsAdmin'); 
        var isInspector: any = $('#InspectionsForm').dxForm('instance').option('IsInspector'); 
 
        //if not isAdmin or not isInspector, Inspection Request Date Time must be 24 hours form now.
        if (isAdmin || isInspector) {
            return;
        } else { 
            let todayDate = new Date();
            let momentDate = moment(todayDate);
            let minRequestDateTime = momentDate.add(24, "hours");

            let momentRequestDateTime = moment(e.value);

            if (momentRequestDateTime < minRequestDateTime) {
                DevExpress.ui.notify("Inspection Request Date Time MUST be at least 24 hours from now!", "warning", 2000);
                dateBoxControl.reset();
            }
        }

    }

    export function twentyfourhourtemplate(data,element) {
        const lineBreak = '<br>';
        const warningText = 'MUST be at least 24 hours from now!';
        const labelText = data.text + lineBreak + warningText 
        element.append(`<div id='template-content'>${labelText}</div>`);

    }

    export function linespacetemplate(data, element) {
        const lineBreak = '<br>';
        const blankLine = ' &nbsp&nbsp ';
        const labelText = lineBreak + data.text + blankLine ;

        element.append(`<div id='template-content'>${labelText}</div>`);
    }








}
